module.exports = __webpack_public_path__ + "sr.d1e92e6cb1b425128269.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sr.svg
// module chunks = styles